import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M9.9885 7.1009C8.3785 2.4509 5.7485 0.210897 3.0485 1.2509C0.428495 2.2709 0.218496 8.10089 3.0185 14.3409C6.3785 21.8309 11.7485 25.1809 11.7485 25.1809C11.7485 25.1809 13.1685 16.2809 9.9885 7.1009Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.09878 13.3609C5.09878 13.3609 3.13878 7.52091 4.65878 5.72091C6.16878 3.93091 9.50878 7.38091 10.6988 17.9709"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M5.09873 13.3609C4.34873 11.5709 3.74873 9.69093 3.69873 7.66093C3.71873 7.15093 3.72873 6.62092 3.94873 6.09092C4.14873 5.58092 4.53873 4.99094 5.25873 4.83094C5.42873 4.82094 5.60873 4.79092 5.77873 4.81092C5.93873 4.85092 6.08873 4.89093 6.24873 4.94093C6.50873 5.08093 6.78873 5.22093 6.97873 5.41093C7.19873 5.59093 7.37873 5.78095 7.54873 5.99095C7.72873 6.19095 7.86873 6.40094 8.01873 6.61094C9.11873 8.34094 9.67873 10.2509 10.0887 12.1609C10.4987 14.0809 10.6687 16.0209 10.7087 17.9609C10.2887 16.0609 9.85873 14.1809 9.32873 12.3509C9.04873 11.4409 8.77873 10.5209 8.41873 9.65092C8.08873 8.77092 7.67873 7.92093 7.17873 7.16093C7.05873 6.97093 6.93873 6.78092 6.78873 6.62092C6.64873 6.44092 6.50873 6.28093 6.34873 6.16093C6.04873 5.88093 5.68873 5.71094 5.43873 5.76094C5.17873 5.79094 4.91873 6.07095 4.75873 6.43095C4.58873 6.79095 4.52873 7.25093 4.47873 7.69093C4.38873 9.53093 4.70873 11.4609 5.09873 13.3609Z"
        fill={outline}
      />
      <path
        d="M68.7983 7.1009C70.4083 2.4509 73.0383 0.210897 75.7383 1.2509C78.3583 2.2709 78.5683 8.10089 75.7683 14.3409C72.4083 21.8309 67.0383 25.1809 67.0383 25.1809C67.0383 25.1809 65.6083 16.2809 68.7983 7.1009Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M73.6879 13.3609C73.6879 13.3609 75.6479 7.52091 74.1279 5.72091C72.6179 3.93091 69.2779 7.38091 68.0879 17.9709"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M73.6881 13.3609C74.0681 11.4709 74.3981 9.53091 74.3081 7.69091C74.2481 7.24091 74.1981 6.78093 74.0281 6.43093C73.8681 6.07093 73.6081 5.79092 73.3481 5.76092C73.0981 5.71092 72.7481 5.88091 72.4381 6.16091C72.2781 6.29091 72.1381 6.4509 71.9981 6.6209C71.8481 6.7809 71.7281 6.97091 71.6081 7.16091C71.1081 7.92091 70.6981 8.7709 70.3681 9.6509C70.0081 10.5209 69.7381 11.4409 69.4581 12.3509C68.9381 14.1909 68.5081 16.0709 68.0781 17.9609C68.1181 16.0209 68.2881 14.0709 68.6981 12.1609C69.1181 10.2509 69.6681 8.34092 70.7681 6.61092C70.9081 6.40092 71.0481 6.18093 71.2381 5.99093C71.3981 5.78093 71.5881 5.59091 71.8081 5.41091C71.9981 5.22091 72.2781 5.08091 72.5381 4.94091C72.6881 4.89091 72.8481 4.85091 73.0081 4.81091C73.1681 4.78091 73.3581 4.81092 73.5281 4.83092C74.2581 4.99092 74.6381 5.5809 74.8381 6.0909C75.0581 6.6209 75.0681 7.15091 75.0881 7.66091C75.0381 9.69091 74.4381 11.5709 73.6881 13.3609Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.91596 8.82008) rotate(61.9922) scale(9.72938 4.71105)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(70.8378 9.02422) rotate(118.008) scale(9.72938 4.71105)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
